<template>
	<app-section class="flex flex-col" :class="$attrs.class">
		<div class="flex items-center">
			<app-title title="Order Details" class="small flex flex-1" />
			<app-button v-if="!order.b2bOrder" class="btn btn-primary transparent small" @click="showProductsModal"
				>Add Products</app-button
			>
		</div>
		<div v-if="order['description']" class="bg-yellow-200 p-4 rounded-lg shadow-md flex flex-col mt-2">
			<span class="text-lg font-bold ">{{ order['description'] }}</span>
		</div>
		<app-line />
		<div v-for="(item, index) in order.items" :key="index" class="order-item-row">
			<div class="flex items-center justify-between gap-3">
				<div class="flex items-center gap-3">
					<img
						v-if="$filters.orderItemImage(item)"
						:src="$filters.setImage($filters.orderItemImage(item))"
						:alt="item['itemName']"
						class="w-12 h-12 flex-shrink-0 rounded-md object-cover cursor-pointer"
						@click="showImage(item)"
					/>
					<div v-else class="w-12 h-12 flex-shrink-0 rounded-md bg-gray-200 flex items-center justify-center">
						<app-icon icon="food" class="text-xl text-secondary" />
					</div>
					<div>{{ item['itemName'] }}</div>
				</div>
				<div class="flex items-center flex-shrink-0 justify-between max-w-sm gap-4">
					<div v-if="isMenuItemDiscount(item)" class="w-18 text-right mr-10 text-muted line-through">
						{{ $filters.formatCurrency(item['menuItem']['oldPrice'], order['currency']) }}
					</div>
					<div class="w-18 mr-10 text-right">{{ item['itemPrice'] }} x {{ item['quantity'] }}</div>
					<div class="text-right mr-2 w-18">
						{{ $filters.formatCurrency(item['itemPrice'] * item['quantity'], order.currency) }}
					</div>
				</div>
			</div>
			<div v-if="item.notes" class="flex px-4 pb-2">
				<div
					class="flex gap-2 place-items-center border-1 border-gray-300 bg-yellow-100 rounded-sm px-4 py-1 max-w-4xl"
				>
					<app-icon icon="doc" class="text-tiny text-secondary" />
					<span class="text-tiny">{{ item.notes }}</span>
				</div>
			</div>
		</div>
	</app-section>
	<app-modal v-if="previewImage" @close="closeImage" @click.self="closeImage">
		<template v-slot:header>
			<h2>{{ previewImageName }}</h2>
		</template>
		<div class="flex flex-col items-center justify-center">
			<img :src="$filters.setImage(previewImage)" :alt="previewImageName" class="order-item-image-modal" />
		</div>
	</app-modal>
	<products-modal
		v-if="isProductsModalVisible"
		:restaurantId="order.restaurant['restaurantID']"
		:restaurantCurrency="order['currency']"
		:customerId="order.customer.id"
		:order="order"
		@close="onModalClose"
	/>
</template>

<script>
	import ProductsModal from '@/components/orders/details/ProductsModal';
	import OrderService from '@/services/OrderService';
	import AppIcon from '@/components/app/AppIcon.vue';
	import AppModal from '@/components/app/AppModal';

	export default {
		name: 'OrdersProduct',
		props: {
			order: {
				required: true,
				type: Object,
			},
		},
		components: {
			AppIcon,
			AppModal,
			ProductsModal,
		},
		data: () => ({
			isProductsModalVisible: false,
			previewImage: null,
			previewImageName: '',
		}),
		methods: {
			showProductsModal() {
				this.isProductsModalVisible = true;
			},
			showImage(item) {
				this.previewImage = this.$filters.orderItemImage(item);
				this.previewImageName = item['itemName'];
			},
			closeImage() {
				this.previewImage = null;
				this.previewImageName = '';
			},
			isMenuItemDiscount(item) {
				return item['menuItem']['oldPrice'] - item['itemPrice'] > 0;
			},
			removeProduct(item) {
				OrderService.removeProduct(this.order.orderID, item.id).then(
					() => {
						this.$emit('updateOrderData');
					},
					(e) => {
						this.$notificationService.error(e);
					}
				);
			},
			onModalClose(products) {
				this.isProductsModalVisible = false;
				if (products) {
					this.$emit('updateOrderData');
				}
			},
		},
	};
</script>

<style scoped>
	.order-item-row:nth-child(odd) {
		background-color: #f0f0f0ee; /* Light grey for odd rows */
	}

	.order-item-row:nth-child(even) {
		background-color: #ffffff; /* White for even rows */
	}

	.order-item-row {
		padding: 5px; /* Add padding for better visibility */
	}

	.order-item-image-modal {
		max-width: calc(100vw - 224px);
		max-height: calc(100vh - 164px);
	}

	.order-item-row:hover {
		background-color: #d3d3d3; /* Light grey for hover effect */
		cursor: pointer; /* Change cursor to pointer */
	}
</style>
